import Title from './src/index.vue'

Title.name = 'HxTitle'

Title.install = (Vue) => {
  Vue.component(Title.name, Title)
}

export default Title
